import { DefaultRepository } from '@/services/base'
import { StreamerEntity } from '@/services/entities/streamer'

export default class RewardRepository extends DefaultRepository<StreamerEntity> {
  constructor() {
    super('/bo/api/v1/rewards')
  }
}
